import type { TFunction } from 'i18next';
import type { DataGridProProps } from '@mui/x-data-grid-pro';

import { getDataGridLocaleText } from '@/shared/utils/dataGridLocalization';

import type { RefuelDataGridRow } from '../../../types/RefuelDataGridRow.types';

type RefuelDataGridOptions = Pick<
  DataGridProProps<RefuelDataGridRow>,
  'sortingOrder' | 'autosizeOptions' | 'getRowHeight' | 'pageSizeOptions' | 'getRowSpacing'
>;

export const REFUEL_DATA_GRID_OPTIONS = {
  sortingOrder: ['asc', 'desc'],
  autosizeOptions: {
    columns: ['refuelDate', 'refuelPlace', 'startFuelLevel', 'stopFuelLevel', 'amountRefuels'],
  },
  getRowHeight: () => 'auto',
  pageSizeOptions: [50, 100],
  getRowSpacing: () => ({ bottom: 10 }),
} satisfies RefuelDataGridOptions;

export function createRefuelDataGridLocaleText(t: TFunction, language: string) {
  return {
    ...getDataGridLocaleText(language),
    noRowsLabel: t('refuels.noResult.noResultDateInterval'),
  } satisfies DataGridProProps<RefuelDataGridRow>['localeText'];
}
